const blogPosts = [
  {
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "How to Start with React",
    summary: "React is a JavaScript library for building user interfaces...",
    author: "Jane Doe",
    date: "March 20, 2024",
    category: "React"
  },
  {
    image: "https://images.unsplash.com/photo-1605379399642-870262d3d051?q=80&w=1206&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Advanced React Techniques",
    summary: "Dive deeper into React with hooks, context, and more...",
    author: "John Doe",
    date: "April 5, 2024",
    category: "React"
  },
  {
    image: "https://plus.unsplash.com/premium_photo-1661277816311-28cced31f998?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Starting a Tech Business in 2025",
    summary: "Here's what you need to know to start a tech business...",
    author: "Sophie Smith",
    date: "June 10, 2024",
    category: "Business"
  },
  {
    image: "https://images.unsplash.com/photo-1589561253898-768105ca91a8?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "How Startups Can Scale Fast",
    summary: "Tips and tools to grow your startup effectively and sustainably.",
    author: "Alex Martin",
    date: "May 18, 2024",
    category: "Startup"
  },
  {
    image: "https://plus.unsplash.com/premium_photo-1679923906308-c26a0e2ca510?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Financial Planning for Entrepreneurs",
    summary: "Understand budgeting, saving, and investing as a founder.",
    author: "Nora Allen",
    date: "July 4, 2024",
    category: "Finance"
  },
  {
    image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?q=80&w=1251&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Mastering SEO in 2025",
    summary: "A complete guide to on-page, off-page, and technical SEO.",
    author: "Liam Davis",
    date: "August 12, 2024",
    category: "Marketing"
  },
  {
    image: "https://images.unsplash.com/photo-1694903089438-bf28d4697d9a?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "AI and the Future of Work",
    summary: "Explore how AI will reshape businesses and job markets.",
    author: "Emily Clark",
    date: "September 1, 2024",
    category: "AI"
  }
];

export default blogPosts;
